<template>
  <div class="goods-item">
    <div class="item-wrap" @click.stop="toDetail">
      <div class="item-wrap-img">
        <img :src="cartItem.image" alt />
        <div class="sellOut" v-if="getLoginStatus.data.member_id&&+cartItem.goodsstock === 0 &&
            getLoadSettingStatus.data.is_empty_stock === 0">缺货</div>
      </div>
      <div class="item-wrap-right">
        <p class="name f15">{{cartItem.general_name}} {{cartItem.norms}}</p>
        <p class="company f12">{{cartItem.produce_unit}}</p>
        <div class="bottom">
          <template v-if="this.getLoginStatus.data.member_id">
            <span class="price f15" v-if="+cartItem.is_view === 1">区域经销</span>
            <span
              class="price f15"
              v-else-if="+cartItem.is_bargain === 1 && +cartItem.tag === 2"
              v-delivery-price
            >议价商品</span>
            <span class="price" v-delivery-price v-else>
              <b>￥</b>
              <span class="f18">{{cartItem.jiage}}</span>
            </span>
          </template>
          <span v-else class="price f15">会员可见</span>
          <cart-btn :btn-type="getGoodsType(item)" @openCart="cartBtn(item)"></cart-btn>
        </div>
        <p v-if="item.is_view" class="mt5">
          <span class="tag">仅销</span>
        </p>
      </div>
    </div>
    <!-- 购物车弹窗start(有库存) -->
      <cc-shop-cart
        getContainer="body"
        :isShowPopup="showcart"
        :cartItemData="cartItem"
        @close="showcart=false"
        :height="556"
        :HeaderHight="88"
        ref="shopCart"
      ></cc-shop-cart>
    <!-- 购物车弹窗end -->
    <!-- 缺货弹窗start-->
      <cc-nogoods-remind
        getContainer="body"
        :isShowPopup="shownogoods"
        :cartItem="cartItem"
        :height="426"
        @close="shownogoods=false"
        ref="nogoods"
      ></cc-nogoods-remind>
    <!-- 缺货弹窗end -->
  </div>
</template>
<script>
import CartBtn from './../components/cart-btn.vue'
import cartStep from '@/mixins/cartStep'
import Command from '@/mixins/command'
export default {
  mixins: [cartStep, Command],
  components: {
    CartBtn
  },
  props: {
    item: {
      type: Object
    }
  },
  data () {
    return {
      cartItem: this.item
    }
  },

  methods: {
    getGoodsType (item) {
      if (this.getLoginStatus.data.member_id) {
        if (item.is_view === 1) {
          return 1 // 区域经销
        } else {
          // 议价商品
          if (+item.is_bargain === 1 && item.tag === 2) {
            return 1
          } else if (
            +item.goodsstock === 0 &&
            this.getLoadSettingStatus.data.is_empty_stock === 0
          ) {
            return 2
          } else {
            return 0
          }
        }
      } else {
        return 0
      }
    },
    cartBtn (item) {
      this.cartBtnAlter(item)
    },
    toDetail () {
      const { cartItem } = this
      this.$router.push({
        path: '/goods-details',
        query: { goods_id: cartItem.id, type: cartItem.for_type }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.goods-item {
  width: 100%;
  min-height: 105px;
  border-radius: 10px;
  background: #fff;
  box-sizing: border-box;
  margin-bottom: 10px;
  .item-wrap {
    padding: 15px 10px 10px 15px;
    display: flex;
    &-img {
      margin-right: 25px;
      width: 75px;
      height: 75px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
      .presell-tag {
        width: 45px;
        height: 18px;
        font-size: 10px;
        background: #ff5b7a;
        opacity: 0.8;
        color: #fff;
        border-radius: 9px;
        @include center();
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    &-right {
      width: 230px;
      .name {
        color: #333333;
        @include ell(1);
      }
      .company {
        color: #777777;
        @include ell(1);
      }
      .bottom {
        display: flex;
        width: 100%;
        height: 24px;
        padding-top: 3px;
        justify-content: space-between;
        align-items: center;
        .price {
          display: inline-block;
          color: #ea2727;
        }
      }
    }
  }
  .tag {
    width: 27px;
    height: 16px;
    display: flex;
    @include center();
    font-size: 10px;
    border-radius: 2px;
    border: 1px solid #999999;
  }
}
</style>
